/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Confirm_BtnInputs */

const en_confirm_btn = /** @type {(inputs: Confirm_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes`)
};

const ar_confirm_btn = /** @type {(inputs: Confirm_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أجل`)
};

const de_confirm_btn = /** @type {(inputs: Confirm_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja`)
};

const es_confirm_btn = /** @type {(inputs: Confirm_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí`)
};

const fr_confirm_btn = /** @type {(inputs: Confirm_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui`)
};

const it_confirm_btn = /** @type {(inputs: Confirm_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì`)
};

const ja_confirm_btn = /** @type {(inputs: Confirm_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい`)
};

const ko_confirm_btn = /** @type {(inputs: Confirm_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`확인`)
};

const pt_br_confirm_btn = /** @type {(inputs: Confirm_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim`)
};

const ru_confirm_btn = /** @type {(inputs: Confirm_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Да`)
};

const th_confirm_btn = /** @type {(inputs: Confirm_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ใช่`)
};

const tr_confirm_btn = /** @type {(inputs: Confirm_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evet`)
};

const zh_cn_confirm_btn = /** @type {(inputs: Confirm_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`确定`)
};

const zh_tw_confirm_btn = /** @type {(inputs: Confirm_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`確定`)
};

/**
* | output |
* | --- |
* | "Yes" |
*
* @param {Confirm_BtnInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const confirm_btn = /** @type {((inputs?: Confirm_BtnInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirm_BtnInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_confirm_btn(inputs)
	if (locale === "ar") return ar_confirm_btn(inputs)
	if (locale === "de") return de_confirm_btn(inputs)
	if (locale === "es") return es_confirm_btn(inputs)
	if (locale === "fr") return fr_confirm_btn(inputs)
	if (locale === "it") return it_confirm_btn(inputs)
	if (locale === "ja") return ja_confirm_btn(inputs)
	if (locale === "ko") return ko_confirm_btn(inputs)
	if (locale === "pt_br") return pt_br_confirm_btn(inputs)
	if (locale === "ru") return ru_confirm_btn(inputs)
	if (locale === "th") return th_confirm_btn(inputs)
	if (locale === "tr") return tr_confirm_btn(inputs)
	if (locale === "zh_cn") return zh_cn_confirm_btn(inputs)
	return zh_tw_confirm_btn(inputs)
});